import { useQuery } from '@hooks/reactQuery';

import { assetProfileIncomingRequests } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAssetProfileIncomingRequests } from '@api/assetProfileIncomingRequests';

import { endOfDayInUTC, startOfDayInUTC } from '@utils/kpi-utils/date';

import { ASSET_PROFILE_INCOMING_REQUESTS } from '@constants/queryKeys';

interface IUseAssetProfileIncomingRequests {
	assetDbId?: string;
	isIncomingRequestsTabShown: boolean;
}

export const useQueryAssetProfileIncomingRequests = ({
	assetDbId,
	isIncomingRequestsTabShown,
}: IUseAssetProfileIncomingRequests) => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		startRentDate,
		endRentDate,
	} = useAppSelector(assetProfileIncomingRequests);

	const {
		data,
		isLoading: isLoadingIncomingRequests,
		isFetching: isFetchingIncomingRequests,
	} = useQuery({
		queryKey: [
			ASSET_PROFILE_INCOMING_REQUESTS,
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
			startRentDate,
			endRentDate,
		],
		queryFn: () => getAssetProfileIncomingRequests({
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
			assetDbId,
			requestedStartDate: startRentDate && startOfDayInUTC(new Date(startRentDate)),
			requestedEndDate: endRentDate && endOfDayInUTC(new Date(endRentDate)),
		}),
		enabled: [!!assetDbId, isIncomingRequestsTabShown],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingIncomingRequests: isLoadingIncomingRequests || isFetchingIncomingRequests,
		incomingRequests: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
